export default "__VITE_ASSET__BVfSjfSk__"